import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { SocketContext } from '../../../socketProvider';
import PopupModal from '../MonitorNav/Notifications/Notification/WarnBtn/PopupModal';
import { socketEventNames } from '../../../helpers/constants';
import { hideWarnPopup, setWarnPopupText, setWarnPopupUserId } from '../MonitorNav/Notifications/Notification/WarnBtn/actions';

const { MONITOR_SEND_USER_WARN, MONITOR_SEND_USER_WARN_RECEIVED } = socketEventNames;

const WarnPopup = ({
  show,
  userId,
  text,
  hideWarnPopupAction,
  setWarnPopupTextAction,
  setWarnPopupUserIdAction,
  userData,
  slugDate,
}) => {
  const [received, setReceived] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const socket = useContext(SocketContext);

  useEffect(() => {
    const handler = (data) => {
      if (data?.userId && data.userId === userId) {
        setReceived((prev) => prev || !!data.received);
        setConfirmed((prev) => prev || !!data.confirmed);
      }
    };
    socket.on(MONITOR_SEND_USER_WARN_RECEIVED, handler);
    return () => {
      socket.off(MONITOR_SEND_USER_WARN_RECEIVED, handler);
    };
  }, [socket, userId]);

  const sendWarning = (targetUserId, msg) => {
    setReceived(false);
    setConfirmed(false);
    const issuedBy = userData?.username || 'unknown';
    socket.emit(MONITOR_SEND_USER_WARN, {
      userId: targetUserId,
      message: msg,
      timestamp: new Date().toISOString(),
      issuedBy,
      slugDate,
    });
  };

  const handleClose = () => {
    hideWarnPopupAction();
    setReceived(false);
    setConfirmed(false);
  };

  return (
    <PopupModal
      isOpen={show}
      onClose={handleClose}
      userId={userId}
      text={text}
      onSendWarning={sendWarning}
      received={received}
      confirmed={confirmed}
      setUserId={setWarnPopupUserIdAction}
      setText={setWarnPopupTextAction}
    />
  );
};

export default connect(
  ({
    monitor: { warnPopup },
    authentication: { userData },
    events: { currentEvent },
  }) => ({
    show: warnPopup.show,
    userId: warnPopup.userId,
    text: warnPopup.text,
    userData,
    slugDate: currentEvent?.slugDate,
  }),
  {
    hideWarnPopupAction: hideWarnPopup,
    setWarnPopupTextAction: setWarnPopupText,
    setWarnPopupUserIdAction: setWarnPopupUserId,
  },
)(WarnPopup);
